/**
 * @generated SignedSource<<601b920e28352974439957cd3ac29cc5>>
 * @relayHash be8915160cd1e937048f76561fffa5f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 794c09dc7f210d7607f049707e2da7bb14fd806ca6a617424d26710a6070ae0c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateContentPropertyBlogUpdateMutation$variables = {
  blogPostId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateContentPropertyBlogUpdateMutation$data = {
  readonly confluence: {
    readonly updateValueBlogPostProperty: {
      readonly blogPostProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateContentPropertyBlogUpdateMutation = {
  response: useUpdateContentPropertyBlogUpdateMutation$data;
  variables: useUpdateContentPropertyBlogUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blogPostId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "blogPostId",
                "variableName": "blogPostId"
              },
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "propertyValue"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
        "kind": "LinkedField",
        "name": "updateValueBlogPostProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "ConfluenceBlogPostProperty",
            "kind": "LinkedField",
            "name": "blogPostProperty",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyBlogUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyBlogUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "be8915160cd1e937048f76561fffa5f6",
    "id": "794c09dc7f210d7607f049707e2da7bb14fd806ca6a617424d26710a6070ae0c",
    "metadata": {},
    "name": "useUpdateContentPropertyBlogUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyBlogUpdateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{updateValueBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{key,value},errors{message}}}}"
  }
};
})();

(node as any).hash = "b6f25f2e222272f4d943290de771b18f";

export default node;
